import { Z as p, T as l, a as T } from "./createReactComponent-58f9bea8.mjs";
import { a as d, i as u, t as n } from "./class-map-2994e95e.mjs";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: B } = p, $ = () => document.createComment(""), b = (t, i, e) => {
  var _;
  const r = t._$AA.parentNode, s = i === void 0 ? t._$AB : i._$AA;
  if (e === void 0) {
    const A = r.insertBefore($(), s), a = r.insertBefore($(), s);
    e = new B(A, a, t, t.options);
  } else {
    const A = e._$AB.nextSibling, a = e._$AM, f = a !== t;
    if (f) {
      let o;
      (_ = e._$AQ) == null || _.call(e, t), e._$AM = t, e._$AP !== void 0 && (o = t._$AU) !== a._$AU && e._$AP(o);
    }
    if (A !== s || f) {
      let o = e._$AA;
      for (; o !== A; ) {
        const c = o.nextSibling;
        r.insertBefore(o, s), o = c;
      }
    }
  }
  return e;
}, R = (t, i, e = t) => (t._$AI(i, e), t), m = {}, v = (t, i = m) => t._$AH = i, x = (t) => t._$AH, y = (t) => {
  var r;
  (r = t._$AP) == null || r.call(t, !1, !0);
  let i = t._$AA;
  const e = t._$AB.nextSibling;
  for (; i !== e; ) {
    const s = i.nextSibling;
    i.remove(), i = s;
  }
}, P = d(class extends u {
  constructor(t) {
    if (super(t), t.type !== n.PROPERTY && t.type !== n.ATTRIBUTE && t.type !== n.BOOLEAN_ATTRIBUTE)
      throw Error("The `live` directive is not allowed on child or event bindings");
    if (t.strings !== void 0)
      throw Error("`live` bindings can only contain a single expression");
  }
  render(t) {
    return t;
  }
  update(t, [i]) {
    if (i === l || i === T)
      return i;
    const e = t.element, r = t.name;
    if (t.type === n.PROPERTY) {
      if (i === e[r])
        return l;
    } else if (t.type === n.BOOLEAN_ATTRIBUTE) {
      if (!!i === e.hasAttribute(r))
        return l;
    } else if (t.type === n.ATTRIBUTE && e.getAttribute(r) === i + "")
      return l;
    return v(t), i;
  }
});
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
export {
  y as M,
  P as l,
  v as m,
  x as p,
  b as r,
  R as v
};
